import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LiveTransferPositionDto } from 'voxr-shared';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { LiveTransferPositionService } from '../../../services/live-transfer-position.service';

@Component({
  selector: 'app-live-transfer-position',
  standalone: true,
  imports: [MatBadgeModule, MatButtonModule, MatMenuModule],
  templateUrl: './live-transfer-position.component.html',
  host: { class: 'tw-block' }
})
export class LiveTransferPositionComponent {
  private positionService = inject(LiveTransferPositionService);

  positions: LiveTransferPositionDto[] = [];
  bestRank?: number;

  constructor() {
    this.positionService.snapshot$.pipe(takeUntilDestroyed()).subscribe(snapshot => {
      this.positions = snapshot?.positions || [];
      this.bestRank = this.positions[0]?.rank;
    });
  }
}
